const component = "section-programming-range";

export const sectionProgrammingRange = {
  component,
  defaultProgram: {
    component: `${component}/default-program`,
    icon: `${component}/default-program/icon`,
    text: `${component}/default-program/text`,
  },
  programmingRange: {
    component: `${component}/programming-range`,
    text: `${component}/programming-range/text`,
    actions: {
      component: `${component}/programming-range/actions`,
      editButton: `${component}/programming-range/actions/edit-button`,
      deleteButton: `${component}/programming-range/actions/delete-button`,
      menuButton: `${component}/programming-range/actions/menu-button`,
    },
  },
  contextMenu: `${component}/context-menu`,
};
